import iconStarFull from '@/core/assets/images/icons/offer-star-full.svg';

import getDeclension from '@/core/helpers/get-declension';

const OfferReviews = ({ props }) => {
    const { offer } = props;

    let rating = null;

    if (offer.rating !== undefined) {
        rating = offer.rating;
    } else if (offer.params?.rating !== undefined) {
        rating = offer.params.rating;
    }

    if (rating !== null) {
        rating = Math.round(rating * 2) / 2;
    }

    const reviewCount = offer.reviewCount;

    const declensions = ['отзыв', 'отзыва', 'отзывов'];

    const reviewsCountText = getDeclension(reviewCount, declensions);

    if (!rating && !reviewCount) {
        return null;
    }

    return (
        <div class="l-ss-c-offer-content-item l-ss-c-offer-content-item-review">
            {rating &&
                <div class="l-ss-c-offer-rating">
                    <i domPropsInnerHTML={iconStarFull}></i>
                    {<span>{rating}</span>}
                </div>
            }
            {reviewCount &&
                <span class="l-ss-c-offer-review-count">{`${reviewCount} ${reviewsCountText}`}</span>
            }
        </div>
    );
};

OfferReviews.props = {
    offer: {
        type: Object,
    },
};

export default OfferReviews;
